import * as React from 'react'
import RedirectPage from 'redirectPage'
import barcodesReportImage from 'images/barcodes-report.png'

const ENGAGE_TOOLS_STATS_TAB_NODE_ID = '4XINHRLFu9'

interface EngageToolsStatsPageProps {
    accountSlug: string
}

const EngageToolsStatsPage = ({ accountSlug }: EngageToolsStatsPageProps) => (
    <RedirectPage
        oldPageTitle="Engage Tools Report"
        newPageTitle="Marketing Report"
        action="is now part of"
        image={barcodesReportImage}
        link={`/account/${accountSlug}/reports/marketing/#${ENGAGE_TOOLS_STATS_TAB_NODE_ID}`}
    />
)

export default EngageToolsStatsPage
